const zh_tw = require("./apexLocales/zh-tw.json")
export default class CONST {

  static realTimeOption = {
      chart: {
        defaultLocale: 'zh-tw',
        type: 'donut',
        stacked: true,
        height: 200,
        toolbar: {
          show: true, // show/hide download button on apexcharts
        },
        zoom: {
          enabled: false, // show/hide zoom button on apexcharts
        },
        locales: [zh_tw],
      },
      labels: ['北口', '中口', '南口'],
      responsive: [{
        breakpoint: 480,
        options: {
          chart: {
            width: 200
          },
          legend: {
            position: 'bottom'
          }
        }
      }],
      plotOptions: {
        pie: {
          donut: {
            labels: {
              show: true,
              total: {
                showAlways: true,
                show: true,
                label: '總數',
                color: '#000000',
             
              }
            }
          }
        }
      },
      dataLabels:{
        enabled: true,
 
      },
      tooltip:{
        y:{
          formatter: function(value) {
            return value +"人"
          }
        }
      }
  } 

}